import autobind from 'autobind-decorator';
import { extendObservable, computed } from 'mobx';

@autobind
class HockeyMatchTeamStatModel {
  constructor(data, rank) {
    extendObservable(this, data);

    this.teamData = null;
    Object.values(rank).map((value, key) => {
      const findTeamData = value.rankings.find((rankValue) => {
        return rankValue.teamId === data.id;
      });
      if (findTeamData !== undefined) {
        this.teamData = findTeamData;
      }
    });
  }
}

export default HockeyMatchTeamStatModel;
